<section
  class="home-v2__hero home-v2__section"
  id="home-seleccion-persona"
  aria-label="Hero"
>
  <div class="home-v2__hero-stage">
    <div class="home-v2__hero-scene">
      <div class="home-v2__hero-panels" aria-hidden="true">
        <div
          class="home-v2__hero-panel home-v2__hero-panel--natural"
          (mouseenter)="onHoverPersona('natural')"
          (mouseleave)="onHoverEnd()"
        >
          <div class="home-v2__hero-panel-bg-wrap">
            <img
              class="home-v2__hero-panel-bg"
              src="assets/img/Home/hero/hero-bg-natural.jpg"
              alt=""
            />
          </div>
          <span
            class="home-v2__hero-panel-shade home-v2__hero-panel-shade--radial home-v2__hero-panel-shade--natural"
            aria-hidden="true"
          ></span>
          <span
            class="home-v2__hero-panel-shade home-v2__hero-panel-shade--linear home-v2__hero-panel-shade--natural"
            aria-hidden="true"
          ></span>
          <div
            class="home-v2__hero-panel-decor"
            [class.home-v2__hero-panel-decor--glow-enhanced]="isGlowEnhanced('natural')"
            aria-hidden="true"
          >
            <img
              class="home-v2__hero-glow home-v2__hero-glow--main"
              src="assets/img/Home/hero/hero-glow-e.svg"
              alt=""
            />
            <img
              class="home-v2__hero-glow home-v2__hero-glow--bottom"
              src="assets/img/Home/hero/hero-glow-e-bottom-pn.svg"
              alt=""
            />
            <div class="home-v2__hero-person home-v2__hero-person--natural">
              <img src="assets/img/Home/hero/hero-person-natural.png" alt="" />
            </div>
          </div>
        </div>

        <div
          class="home-v2__hero-panel home-v2__hero-panel--juridica"
          (mouseenter)="onHoverPersona('juridica')"
          (mouseleave)="onHoverEnd()"
        >
          <div class="home-v2__hero-panel-bg-wrap">
            <img
              class="home-v2__hero-panel-bg"
              src="assets/img/Home/hero/hero-bg-juridica.jpg"
              alt=""
            />
          </div>
          <span
            class="home-v2__hero-panel-shade home-v2__hero-panel-shade--radial home-v2__hero-panel-shade--juridica"
            aria-hidden="true"
          ></span>
          <span
            class="home-v2__hero-panel-shade home-v2__hero-panel-shade--linear home-v2__hero-panel-shade--juridica"
            aria-hidden="true"
          ></span>
          <div
            class="home-v2__hero-panel-decor"
            [class.home-v2__hero-panel-decor--glow-enhanced]="isGlowEnhanced('juridica')"
            aria-hidden="true"
          >
            <img
              class="home-v2__hero-glow home-v2__hero-glow--main"
              src="assets/img/Home/hero/hero-glow-e.svg"
              alt=""
            />
            <div class="home-v2__hero-person home-v2__hero-person--juridica">
              <img src="assets/img/Home/hero/hero-person-juridica.png" alt="" />
            </div>
            <img
              class="home-v2__hero-glow home-v2__hero-glow--bottom"
              src="assets/img/Home/hero/hero-glow-e-bottom-pj.svg"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="home-v2__hero-copy">
        <p class="home-v2__hero-eyebrow" [innerHTML]="eyebrowSafe"></p>

        <h1 class="home-v2__hero-title" [innerHTML]="titleSafe"></h1>

        <p class="home-v2__hero-subtitle" [innerHTML]="subtitleSafe"></p>

        <div class="home-v2__hero-actions">
          <button
            type="button"
            class="home-v2__hero-btn home-v2__hero-btn--natural"
            [class.home-v2__hero-btn--highlighted]="isButtonHighlighted('natural')"
            id="btn-home-persona-natural"
            (mouseenter)="onHoverPersona('natural')"
            (mouseleave)="onHoverEnd()"
            (focus)="onHoverPersona('natural')"
            (blur)="onHoverEnd()"
            (click)="onSelectPersona('natural')"
          >
            <svg
              class="home-v2__hero-btn-icon"
              width="24"
              height="24"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
                fill="currentColor"
              />
            </svg>
            <span>{{ content.ctaNatural }}</span>
          </button>

          <button
            type="button"
            class="home-v2__hero-btn home-v2__hero-btn--juridica"
            [class.home-v2__hero-btn--highlighted]="isButtonHighlighted('juridica')"
            id="btn-home-persona-juridica"
            (mouseenter)="onHoverPersona('juridica')"
            (mouseleave)="onHoverEnd()"
            (focus)="onHoverPersona('juridica')"
            (blur)="onHoverEnd()"
            (click)="onSelectPersona('juridica')"
          >
            <span>{{ content.ctaJuridica }}</span>
            <svg
              class="home-v2__hero-btn-icon"
              width="24"
              height="24"
              viewBox="0 0 18.3576 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M2.17878 2H16.1788C16.7288 2 17.1788 1.55 17.1788 1C17.1788 0.45 16.7288 0 16.1788 0H2.17878C1.62878 0 1.17878 0.45 1.17878 1C1.17878 1.55 1.62878 2 2.17878 2ZM17.3388 3.8C17.2488 3.34 16.8388 3 16.3588 3H1.99878C1.51878 3 1.10878 3.34 1.01878 3.8L0.0187845 8.8C-0.101215 9.42 0.368785 10 0.998785 10H1.17878V15C1.17878 15.55 1.62878 16 2.17878 16H10.1788C10.7288 16 11.1788 15.55 11.1788 15V10H15.1788V15C15.1788 15.55 15.6288 16 16.1788 16C16.7288 16 17.1788 15.55 17.1788 15V10H17.3588C17.9888 10 18.4588 9.42 18.3388 8.8L17.3388 3.8V3.8ZM9.17878 14H3.17878V10H9.17878V14Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
